var OverridingExperimentClient = /** @class */ (function () {
    function OverridingExperimentClient(underlyingExperimentClient, config) {
        this.underlyingExperimentClient = underlyingExperimentClient;
        this.forceDefaultTreatments = config.forceDefaultTreatments || false;
        this.treatment = this.treatment.bind(this);
        var experimentOverrides = config.experimentOverrides;
        /**
         * Collect all experiment & variation pairs => [header:v2, phoneQuiz:on]
         */
        var forcedExperimentVariations = experimentOverrides && experimentOverrides.split(',');
        var forcedVariations = {};
        /**
         * Convert array values to a mapped object of type {experiment: variaton}
         * EX: { header: `v2`, phoneQuiz: `on`}
         */
        forcedExperimentVariations &&
            forcedExperimentVariations.forEach(function (forcedExperimentVariation) {
                var _a = forcedExperimentVariation.split(':'), experiment = _a[0], variation = _a[1];
                // Need both, passing a null variation resets the forced override
                if (!experiment || !variation) {
                    console.warn('Incorrectly formatted experiment override passed', forcedExperimentVariation);
                    return false;
                }
                forcedVariations[experiment] = variation;
            });
        this.forcedExperimentVariations = forcedVariations;
    }
    OverridingExperimentClient.prototype.treatment = function (_a) {
        var id = _a.id, experiment = _a.experiment, attributes = _a.attributes, defaultTreatment = _a.defaultTreatment;
        var forcedVariationExperiment = this.forcedExperimentVariations[experiment];
        /**
         * If there is a forced variation for the provided experiment short-circuit underlying call to `treatment()` and provided the forced variation
         */
        if (forcedVariationExperiment) {
            return {
                result: forcedVariationExperiment,
                promise: Promise.resolve(forcedVariationExperiment),
                active: Promise.resolve(true),
                changeNumber: Promise.resolve(-1)
            };
        }
        else if (this.forceDefaultTreatments && defaultTreatment) {
            return {
                result: defaultTreatment,
                promise: Promise.resolve(defaultTreatment),
                active: Promise.resolve(true),
                changeNumber: Promise.resolve(-1)
            };
        }
        else {
            /**
             * Options aren't used in any of the underlyuing treatment methods so we can safely drop them here
             */
            return this.underlyingExperimentClient.treatment({
                id: id,
                experiment: experiment,
                attributes: attributes,
                options: {}
            });
        }
    };
    return OverridingExperimentClient;
}());

export { OverridingExperimentClient };
//# sourceMappingURL=overriding.js.map
